import { useEffect } from "react";
import { singularService } from "@medbillai/app/lib/singular/singular";
import type { SingularConfigProps } from "@medbillai/app/lib/singular/types";

// Although "useEffect" will only run the hook once per mount, hot reloading can
// cause us to mount multiple times, so track initialization separately to avoid
// error noise.
let initialized = false;
export function useSingularService() {
  // Initialize singular service on mount (client-side only)
  useEffect(() => {
    if (initialized) {
      return;
    }
    initialized = true;
    // Double-check that we're in the browser
    if (typeof window === "undefined") {
      return;
    }
    if (!process.env.NEXT_PUBLIC_SINGULAR_SDK_KEY || !process.env.NEXT_PUBLIC_SINGULAR_SDK_SECRET) {
      console.error("[SINGULAR] NEXT_PUBLIC_SINGULAR_SDK_KEY/_SECRET missing — install tracking disabled");
      return;
    }
    const config: SingularConfigProps = {
      singularSdkKey: process.env.NEXT_PUBLIC_SINGULAR_SDK_KEY,
      singularSdkSecret: process.env.NEXT_PUBLIC_SINGULAR_SDK_SECRET,
      singularFacebookAppId: "",
      // Not needed for web implementation
      singularTrackingEnabled: true
    };
    try {
      void singularService.initialize(config);
    } catch (error) {
      console.error("[SINGULAR]: Failed to initialize:", error);
    }
  }, []);
}